<template>
    <div 
        v-if="showPage"
        class="fixed bottom-10 right-10 shadow-md bg-gray-50 p-3 border-4 cursor-pointer"
        :class="[
            {
                'border-green': todayLoads.status === 'ahead',
                'border-red-600': todayLoads.status === 'behind' || todayLoads.status === 'already_behind',
                'border-yellow-600': todayLoads.status === 'on'
            },
            {
                'rounded-full': !isExpanded,
                'rounded-2xl': isExpanded
            },
            {
                'opacity-75': loading
            }
        ]"
        @click="!loading ? isExpanded = !isExpanded : null"
    >
        <div class="font-bold uppercase tracking-widest">
            <i class="fa-solid fa-circle text-xs mr-2" 
                :class="{
                    'text-red-600': todayLoads.status === 'behind' || todayLoads.status === 'already_behind',
                    'text-yellow-600': todayLoads.status === 'on',
                    'text-green': todayLoads.status === 'ahead',
                }"
            />
            <span v-if="loading">Loading</span>
            <span v-if="todayLoads.status === 'behind' || todayLoads.status === 'already_behind'">Behind Schedule</span>
            <span v-if="todayLoads.status === 'on'">On Schedule</span>
            <span v-if="todayLoads.status === 'ahead'">Ahead of Schedule</span>
            -
            {{ division }}
        </div>

        <div v-if="isExpanded" class="mt-3">
            Goal Item / Hour: 
            <i v-if="todayLoads.status === 'already_behind'" class="fa-solid fa-infinity"></i>
            <span v-else class="font-bold">
                {{ (todayLoads.goalPickRate ?? 0).toFixed(2) }}
            </span>
            <br>
            Current Item / Hour: <span class="font-bold">{{ todayLoads.pickingData?.itemsPerHour.toFixed(2) }}</span><br>
            
            <div>
                Items {{  aheadOrBehind }} Schedule:
                <span class="font-bold">{{todayLoads.itemsAheadOrBehindSchedule.toFixed(2)}}</span>
            </div>
            <div>
                Minutes {{ aheadOrBehind }} Schedule:
                <i v-if="todayLoads.minutesAheadOrBehindSchedule === null" class="fa-solid fa-infinity"></i>
                <span v-else class="font-bold">{{ todayLoads.minutesAheadOrBehindSchedule.toFixed(2)}}</span>
            </div>

            <div v-if="todayLoads.behindScheduleLoads.length > 0">
                <div>Loads Behind Schedule: </div>
                <div v-for="load in todayLoads.behindScheduleLoads" :key="load.id" class="my-4">
                    <jet-button 
                        :href="`/loads/${load.id}`"
                        @click.stop=""
                    >
                        #{{ load.id }} - {{ formatTimestamp(load.calculated_departure_time, 'h:mm a') }}
                    </jet-button>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3';
import JetButton from '@/Jetstream/Button';

export default {

data() {
    return {
        fetchDataInterval: null,
        loading: true,
        todayLoads: { // will be updated by fetchLoadsStatus periodically
            status: '',
            behindScheduleLoads: [],
            pickingData: {},
            goalPickRate: 0,
            itemsAheadOrBehindSchedule: 0,
            minutesAheadOrBehindSchedule: 0
        },
        isExpanded: false,
        division: 'all',
    }
},

components: {
    JetButton
},

computed: {
    showPage(){
        const page = usePage();

        let user = page.props.value.user;
        if (user.id !== 13 && user.id !== 911) return false;

        let path = page.url.value.split('?')[0];

        const pattern = /^(\/loads(\/\d+)?|\/orders\/\d+\/(checking|picking)|\/picking)$/;
    
        return pattern.test(path);
    },

    aheadOrBehind(){
        if (this.todayLoads.status === 'behind' || this.todayLoads.status === 'already_behind') return 'Behind';
        else if(this.todayLoads.status === 'ahead' || this.todayLoads.status === 'on') return 'Ahead of';
        return '';
    },
},

methods: {
    fetchLoadsStatus() {
        axios.get(`/loads/scheduleStatus`)
            .then((response) => {
                this.division = response.data.division;
                this.todayLoads = response.data[this.division];
                this.loading = false;
            });
    }

},
mounted(){
    if (this.showPage) {
        this.fetchLoadsStatus();
    }
},

created(){
    if (this.showPage) {
        this.fetchDataInterval = setInterval(() => {
            this.fetchLoadsStatus();
        }, 60 * 1000)
    }
},

beforeUnmount() {
    if (this.showPage) {
        clearInterval(this.fetchDataInterval);
    }
},

}


</script>